export const emailSettingState = {
    errorCode : 0,
    statusCode : 0,
    emailSettingList : [],
    updatedEmailSetting : {},
    Message : '',
    SubjectList : [],
    isLoading : false,
    SMTPdetail : {},
    emailLogoDetail : {}
}